export default {
  全部交易产品: "Tất cả sản phẩm giao dịch",
};
